const MICROAPP_BANNER_DISMISSED = 'dismissedMicroappBanner';
export const getIsBannerDismissed = storage => storage.getItem(MICROAPP_BANNER_DISMISSED);
export const setBannerDismissed = storage => storage.setItem(MICROAPP_BANNER_DISMISSED, true);